// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3yztm","select":"Header_select__3AIfA","clinic":"Header_clinic__3Tpn9"};